import { StyleSheet } from "react-native";
import { theme } from "../theme/theme";
import {
  locationPickChip,
  locationPickChipSelected,
  locationPickChipText,
  locationPickChipTextSelected,
} from "./listingBadgeStyles";

/** FAB — solid brand orange; 75% of default 56px diameter (use with customSize prop) */
export const FAB_SIZE = 42;

/** Screen roots / scroll areas — transparent so AppBackground watermark shows through */
export const SCREEN_ROOT_BG = "transparent";

/** Extra scroll padding so the watermark is visible below last list items */
export const WATERMARK_SCROLL_PADDING = 96;

export const fabShell = {
  backgroundColor: theme.colors.primary,
  elevation: 6,
  shadowColor: "#000",
  shadowOffset: { width: 0, height: 3 },
  shadowOpacity: 0.3,
  shadowRadius: 4,
};

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: SCREEN_ROOT_BG,
    position: "relative",
  },
  debugHeader: {
    backgroundColor: "#000000",
    paddingVertical: 8,
    paddingHorizontal: 16,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  debugText: {
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: "600",
    fontFamily: "Poppins",
    textAlign: "center",
  },
  content: {
    flex: 1,
    position: "relative",
    zIndex: 2,
    backgroundColor: SCREEN_ROOT_BG,
  },
  appContentLayer: {
    flex: 1,
    position: "relative",
    zIndex: 2,
    backgroundColor: SCREEN_ROOT_BG,
  },
  contentFullScreen: {
    flex: 1,
  },
  // Shown in place of the mock payment screens outside development.
  paymentsUnavailable: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing.xl,
    backgroundColor: theme.colors.background,
  },
  paymentsUnavailableTitle: {
    fontSize: 20,
    fontWeight: "600",
    fontFamily: "Poppins",
    color: theme.colors.onBackground,
    marginBottom: theme.spacing.sm,
    textAlign: "center",
  },
  paymentsUnavailableBody: {
    fontSize: 15,
    fontFamily: "Poppins",
    color: theme.colors.onSurfaceVariant,
    lineHeight: 22,
    textAlign: "center",
    maxWidth: 380,
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.colors.background,
    zIndex: 1000,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: theme.colors.surface,
    borderRadius: theme.borderRadius.lg,
    padding: theme.spacing.xl,
    margin: theme.spacing.lg,
    minWidth: 280,
    maxWidth: 400,
    alignItems: "center",
    elevation: 5,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "600",
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
    marginBottom: theme.spacing.md,
    textAlign: "center",
  },
  modalMessage: {
    fontSize: 16,
    color: theme.colors.onSurfaceVariant,
    fontFamily: "Poppins",
    marginBottom: theme.spacing.xl,
    textAlign: "center",
    lineHeight: 22,
  },
  modalButtons: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  modalButton: {
    flex: 1,
    paddingVertical: theme.spacing.md,
    paddingHorizontal: theme.spacing.lg,
    borderRadius: theme.borderRadius.md,
    marginHorizontal: theme.spacing.sm,
    alignItems: "center",
  },
  cancelButton: {
    backgroundColor: theme.colors.surfaceVariant,
  },
  cancelButtonText: {
    color: theme.colors.onSurfaceVariant,
    fontSize: 16,
    fontWeight: "600",
    fontFamily: "Poppins",
  },
  signOutButton: {
    backgroundColor: theme.colors.primary,
  },
  signOutButtonText: {
    color: theme.colors.onPrimary,
    fontSize: 16,
    fontWeight: "600",
    fontFamily: "Poppins",
  },

  // Location Modal Styles
  locationModalContainer: {
    flex: 1,
    backgroundColor: theme.colors.background,
    zIndex: 10000,
    elevation: 10,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  locationModalHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: theme.spacing.lg,
    paddingVertical: theme.spacing.md,
    borderBottomColor: theme.colors.outline,
    backgroundColor: theme.colors.surface,
  },
  locationModalCloseButton: {
    padding: theme.spacing.sm,
  },
  locationModalTitle: {
    fontSize: 20,
    fontWeight: "600",
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
  },
  locationModalHeaderSpacer: {
    width: 40,
  },
  locationModalContent: {
    flex: 1,
    paddingHorizontal: theme.spacing.lg,
  },
  locationModalSection: {
    marginBottom: theme.spacing.sm,
  },
  locationModalSectionTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
    marginTop: theme.spacing.md,
    marginBottom: theme.spacing.md,
  },
  locationModalSearchContainer: {},
  locationModalSearchBar: {
    backgroundColor: theme.colors.surfaceVariant,
    flexDirection: "row",
    alignItems: "center",
  },
  locationModalSearchIcon: {
    marginLeft: theme.spacing.md,
    marginRight: theme.spacing.sm,
  },
  locationModalSearchInput: {
    flex: 1,
    color: theme.colors.onSurface,
    fontSize: 16,
    fontFamily: "Poppins",
    paddingVertical: theme.spacing.sm,
    paddingLeft: 8,
    paddingRight: theme.spacing.sm,
    backgroundColor: "transparent",
    borderWidth: 0,
    borderBottomWidth: 0,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    textDecorationLine: "none",
  },
  locationModalSuggestionsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: theme.spacing.sm,
  },
  locationModalSuggestionItem: {
    backgroundColor: theme.colors.surface,
    borderRadius: 8,
    paddingHorizontal: theme.spacing.md,
    paddingVertical: theme.spacing.sm,
    borderWidth: 1,
    borderColor: theme.colors.outline,
    minWidth: "45%",
    marginBottom: theme.spacing.sm,
  },
  locationModalSuggestionRow: {
    paddingVertical: theme.spacing.sm,
    paddingHorizontal: theme.spacing.xs,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.outline,
  },
  locationModalSuggestionText: {
    fontSize: 16,
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
  },
  locationModalChipsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: theme.spacing.sm,
  },
  locationModalChip: locationPickChip,
  locationModalChipSelected: locationPickChipSelected,
  locationModalChipText: locationPickChipText,
  locationModalChipTextSelected: locationPickChipTextSelected,
  locationModalSelectedChip: { ...locationPickChipSelected, backgroundColor: theme.colors.primary },
  locationModalSelectedChipText: { ...locationPickChipTextSelected, color: theme.colors.onPrimary },
  locationModalFooter: {
    padding: theme.spacing.md,
    borderTopWidth: 1,
    borderTopColor: theme.colors.outline,
    backgroundColor: theme.colors.surface,
  },
  locationModalDoneButton: {
    backgroundColor: theme.colors.primary,
    borderRadius: 8,
    paddingVertical: theme.spacing.md,
    paddingHorizontal: theme.spacing.lg,
    alignItems: 'center',
  },
  locationModalDoneButtonDisabled: {
    backgroundColor: theme.colors.outline,
    opacity: 0.6,
  },
  locationModalDoneButtonText: {
    color: theme.colors.onPrimary,
    fontSize: 16,
    fontWeight: '600',
    fontFamily: 'Poppins',
  },

  // Testimonials Modal Styles
  testimonialsModalContainer: {
    flex: 1,
    backgroundColor: theme.colors.background,
    zIndex: 10000,
    elevation: 10,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  testimonialsModalHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: theme.spacing.lg,
    paddingVertical: theme.spacing.md,
    backgroundColor: theme.colors.primary,
  },
  testimonialsModalCloseButton: {
    padding: theme.spacing.sm,
  },
  testimonialsModalHeaderText: {
    flex: 1,
    alignItems: "center",
  },
  testimonialsModalTitle: {
    fontSize: 20,
    fontWeight: "600",
    color: "#FFFFFF",
    fontFamily: "Poppins",
    textAlign: "center",
  },
  testimonialsModalSubtitle: {
    fontSize: 14,
    color: "#FFFFFF",
    fontFamily: "Poppins",
    textAlign: "center",
    opacity: 0.8,
    marginTop: 2,
  },
  testimonialsModalSearchButton: {
    padding: theme.spacing.sm,
  },
  testimonialsModalContent: {
    flex: 1,
    paddingHorizontal: theme.spacing.lg,
  },
  testimonialsModalSearchContainer: {
    marginBottom: theme.spacing.md,
  },
  testimonialsModalSearchInput: {
    backgroundColor: theme.colors.surface,
    borderRadius: theme.borderRadius.md,
    paddingHorizontal: theme.spacing.md,
    paddingVertical: theme.spacing.sm,
    fontSize: 16,
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
    borderWidth: 1,
    borderColor: theme.colors.outline,
  },
  testimonialsModalFilterContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: theme.spacing.md,
    marginBottom: theme.spacing.lg,
    flexWrap: "wrap",
  },
  testimonialsModalFilterButton: {
    backgroundColor: theme.colors.surface,
    paddingHorizontal: theme.spacing.md,
    paddingVertical: theme.spacing.sm,
    borderRadius: theme.borderRadius.md,
    borderWidth: 1,
    borderColor: theme.colors.outline,
    minWidth: "15%",
    alignItems: "center",
  },
  testimonialsModalFilterButtonActive: {
    backgroundColor: theme.colors.primary,
    borderColor: theme.colors.primary,
  },
  testimonialsModalFilterButtonText: {
    fontSize: 14,
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  testimonialsModalFilterButtonTextActive: {
    color: "#FFFFFF",
  },
  testimonialsModalItem: {
    backgroundColor: theme.colors.surface,
    borderRadius: theme.borderRadius.md,
    padding: theme.spacing.lg,
    marginBottom: theme.spacing.md,
    borderWidth: 1,
    borderColor: theme.colors.outline,
  },
  testimonialsModalItemLast: {
    marginBottom: theme.spacing.xl,
  },
  testimonialsModalItemHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing.sm,
  },
  testimonialsModalItemByline: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    minWidth: 0,
    gap: 8,
    marginRight: theme.spacing.sm,
  },
  testimonialsModalItemName: {
    fontSize: 16,
    fontWeight: "600",
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
    flexShrink: 1,
  },
  testimonialsModalItemRating: {
    flexDirection: "row",
  },
  testimonialsModalItemDate: {
    fontSize: 14,
    color: theme.colors.onSurfaceVariant,
    fontFamily: "Poppins",
    marginBottom: theme.spacing.sm,
  },
  testimonialsModalItemComment: {
    fontSize: 16,
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
    lineHeight: 22,
  },
  testimonialsModalResponseActions: {
    marginTop: theme.spacing.md,
  },
  testimonialsModalRespondButton: {
    borderRadius: 8,
    alignSelf: "flex-start",
  },
  testimonialsModalEmpty: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: theme.spacing.xl,
  },
  testimonialsModalEmptyText: {
    fontSize: 16,
    color: theme.colors.onSurfaceVariant,
    fontFamily: "Poppins",
    textAlign: "center",
  },

  // Services FAB
  servicesFabOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    pointerEvents: "box-none",
  },
  servicesFab: {
    position: "fixed",
    right: 54,
    bottom: 60,
    ...fabShell,
    zIndex: 9999,
  },
});
